module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/tactical-training-elite.3f99547f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/tactical-training-elite.png
// module id = 3750
// module chunks = 11